import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Technology from "@/pages/Technology";
import Pricing from "@/pages/Pricing";
import FAQ from "@/pages/FAQ";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import Legal from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<Book />} />
            <Route path="/legal/:slug" element={<Legal />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
